export const TileTypes = {
  browse: 'browse',
  lists: 'lists',
  recommended: 'recommended',
  report: 'report',
  wmt: 'wmt',
  deals: 'deals',
  news: 'news',
  betterBuys: 'betterBuys',
  equipmentSuppliesTile: 'equipmentSuppliesTile',
};

export const RECENTLY_VIEWED = 'recently viewed';
export const TOP_SELLERS = 'top sellers';
export const LINK_SOURCE_RECENTLY_VIEWED = 'recentlyViewed';
export const RECENTLY_VIEWED_MAX_ITEMS = 50;
